import { apiRequest } from '@/utils/api-request';

export interface SoftwareRepoStatus {
  configured: boolean;
  provider: 'github' | null;
  default_repo_url?: string | null;
  default_repo_full_name?: string | null;
  default_branch?: string | null;
  default_repo_source?: 'platform_fallback' | 'organization_override' | null;
  default_branch_source?: 'platform_fallback' | 'organization_override' | null;
  org_config_available?: boolean;
}

export const getSoftwareRepoStatus = async (
  orgId: string,
): Promise<SoftwareRepoStatus> => {
  const response = await apiRequest<SoftwareRepoStatus>({
    url: `/api/v1/orgs/${orgId}/software-repo/status`,
    method: 'GET',
    target: 'workflow',
  });

  if (response?.detail) {
    throw new Error(response.detail || 'Failed to get software repo status');
  }

  return response.data ?? { configured: false, provider: null };
};
